import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Authentication from '../../components/Authentication';
import './styles.sass';

const useStyles = makeStyles({
    text: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`,
            zIndex: 1,
            marginBottom: 20
        }
    },
    button: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`,
            fontSize: 17,
            borderRadius: 15,
            height: 45,
            width: 140,
            color: 'white',
            backgroundColor: 'transparent',
            border: '2px solid #000f14CC',
            zIndex: 1,
            '&:hover': {
                backgroundColor: '#000f14CC',
                transition: 'all 0.5 ease-in-out'
            }
        }
    }
});

const Home = () => {
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    document.title = 'CookEat';

    return (
        <div className="home-container">
            <Typography variant='h4' className={classes.text}>נמאס לכם ממתכונים מבולגנים? <br /> זה המקום לסדר אותם!</Typography>
            <Button className={classes.button} onClick={() => setOpen(true)}>בואו נתחיל!</Button>
            <Authentication
                open={open}
                setOpen={setOpen}
            />
            <ToastContainer
                rtl
                position="bottom-center"
                autoClose={5000}
                closeOnClick
                closeButton={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme='dark'
            />
        </div>
    )
}

export default Home;